"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std.base */
//================================================================

/**
 * @hidden
 */

var _DequeForOfAdaptor =
/** @class */
function () {
  function _DequeForOfAdaptor(matrix) {
    this.matrix_ = matrix;
    this.row_ = 0;
    this.col_ = 0;
  }

  _DequeForOfAdaptor.prototype.next = function () {
    if (this.row_ === this.matrix_.length) return {
      done: true,
      value: undefined
    };else {
      var val = this.matrix_[this.row_][this.col_];

      if (++this.col_ === this.matrix_[this.row_].length) {
        ++this.row_;
        this.col_ = 0;
      }

      return {
        done: false,
        value: val
      };
    }
  };

  _DequeForOfAdaptor.prototype[Symbol.iterator] = function () {
    return this;
  };

  return _DequeForOfAdaptor;
}();

exports._DequeForOfAdaptor = _DequeForOfAdaptor;